import { useId, useState } from 'react';
import { Modal } from './Modal';

interface AckWarning {
  id: string;
  title: string;
  detail: string;
}

interface AckDialogProps {
  warnings: AckWarning[];
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/** S06. The confirm button stays disabled until the admin ticks the box themselves; the server records exactly which warnings were reviewed. */
export function AckDialog({ warnings, busy, error, onCancel, onConfirm }: AckDialogProps) {
  const titleId = useId();
  const bodyId = useId();
  const [checked, setChecked] = useState(false);
  return (
    <Modal titleId={titleId} describedById={bodyId} onClose={onCancel} busy={busy} closeLabel="Close warnings">
      <h3 id={titleId} className="wc-modal__title wc-modal__title--warn"><span aria-hidden="true">●</span> Review Warnings Before Proceeding</h3>
      <p id={bodyId}>
        The readiness check found {warnings.length} {warnings.length === 1 ? 'warning' : 'warnings'} for this payment batch. You may proceed, but you
        are acknowledging that you have reviewed and accepted the following conditions:
      </p>
      <ul className="wc-modal__list">
        {warnings.map((w) => (
          <li key={w.id}>
            <strong>{w.title}</strong>
            <p>{w.detail}</p>
          </li>
        ))}
      </ul>
      <label className="wc-check">
        <input type="checkbox" checked={checked} disabled={busy} onChange={(e) => setChecked(e.target.checked)} />
        <span>I have reviewed the warnings above and confirm I want to proceed with this payment batch.</span>
      </label>
      {error && <p className="error" role="alert">{error}</p>}
      <div className="wc-modal__actions">
        <button type="button" className="wc-btn wc-btn--outline" onClick={onCancel} disabled={busy}>Cancel</button>
        <button type="button" className="wc-btn wc-btn--primary" onClick={onConfirm} disabled={!checked || busy}>
          I Acknowledge, Proceed to Review
        </button>
      </div>
    </Modal>
  );
}
